import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { RefusedActions } from './refused.actions';
import { IRefusedState } from './refused.state';

export const initialRefusedState: IRefusedState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const refusedReducerFn = createReducer(
  initialRefusedState,
  on(RefusedActions.reset, (state: IRefusedState, action) => {
    return new StateBuilder<IRefusedState>(initialRefusedState).build();
  }),
  on(RefusedActions.load, (state: IRefusedState, action) => {
    return new StateBuilder<IRefusedState>(state).toLoading().build();
  }),
  on(RefusedActions.loadSuccess, (state: IRefusedState, action) => {
    return new StateBuilder<IRefusedState>(state, action).toLoaded().build();
  }),
  on(RefusedActions.submit, (state: IRefusedState, action) => {
    return new StateBuilder<IRefusedState>(state).toLoading().build();
  }),
  on(RefusedActions.submitSuccess, (state: IRefusedState, action) => {
    return new StateBuilder<IRefusedState>(state, action).toLoaded().build();
  })
);

export function refusedReducer(state: IRefusedState | undefined, action: Action) {
  return refusedReducerFn(state, action);
}
